var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsdtBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 220,
    viewBox: "0 0 360 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_426",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 360,
    height: 220
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 220,
    rx: 21,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_426)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_426)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.187,
    y: 237.167,
    width: 464.187,
    height: 283.167,
    rx: 21,
    transform: "rotate(180 412.187 237.167)",
    fill: "url(#paint0_linear_1_426)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1_426)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 361.5,
    cy: 190.5,
    r: 136.5,
    fill: "#1DD97E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1_426)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 28,
    r: 77,
    fill: "#B4F383"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_426",
    x: -79.0002,
    y: -72.9999,
    width: 518.187,
    height: 337.167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5,
    result: "effect1_foregroundBlur_1_426"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1_426",
    x: 105,
    y: -66,
    width: 513,
    height: 513,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_1_426"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1_426",
    x: -155,
    y: -158,
    width: 372,
    height: 372,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 54.5,
    result: "effect1_foregroundBlur_1_426"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_426",
    x1: 846.635,
    y1: 265.613,
    x2: 437.187,
    y2: 538.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#119144"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtBg);
export default __webpack_public_path__ + "static/media/usdt_bg.40018f0533b785adb132b8a342d7a5a2.svg";
export { ForwardRef as ReactComponent };